import * as React from 'react';
import { observer } from 'mobx-react';

import FreebusyStore from '../../../../../FreebusyStore';
import ScheduleButtonView from './ScheduleButtonView';

interface Props {
  freebusyStore: FreebusyStore;
}

class Button extends React.Component<Props, {}> {
  componentDidMount() {
    this.props.freebusyStore.loading();
  }

  render() {
    // FreeBusy opens its picker from the button id.
    return (
      <ScheduleButtonView
        buttonId="freebusy-leadership-coaching-button"
        disabled={this.props.freebusyStore.schedulingDisabled}
        onClick={() => {}}
      />
    );
  }
}

export default observer(Button);
